export const useServicesFilter = () => {
  const showUsedOnly = useState<boolean>('services-filter-used-only', () => false)

  const toggleUsedOnly = () => {
    showUsedOnly.value = !showUsedOnly.value
  }

  const resetFilter = () => {
    showUsedOnly.value = false
  }

  return {
    showUsedOnly,
    toggleUsedOnly,
    resetFilter,
  }
}

